<template>
     <v-app>
      <v-main>
        <v-container fluid >
          <v-row
            align="center"
            justify="center"
          >
            <v-card class="elevation-12">

              <!-- TOOLBAR -->
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-img
                  src="meggsimum-logo-square.png"
                  max-height="50"
                  max-width="50"
                  contain
                />
                <v-spacer></v-spacer>
                <v-toolbar-title
                  :class="{
                      appTitle: $vuetify.breakpoint.mobile
                  }"
                >{{toolbarTitle}}

                </v-toolbar-title>

                <!-- badge to show that version is still 'beta' -->
                <v-badge
                  color="orange"
                  content="beta"
                  :class="{
                      betaBadge: $vuetify.breakpoint.smAndUp,
                      betaBadgeMobile: $vuetify.breakpoint.xs
                  }"
                />

                <v-spacer></v-spacer>
                <InfoWindow></InfoWindow>
              </v-toolbar>

              <!-- BANNER -->
              <v-img
                height="200"
                src="img/ronnie-george-z11gbBo13ro-unsplash.jpg"
              />

              <!-- INPUT -->
              <v-card-text>
                <v-form>
                  <v-container>
                    <v-row>
                      <v-select
                        v-model="buildingTypeSelect"
                        :items="buildingTypeItems"
                        label="Gebäudeart"
                        prepend-icon="mdi-home"
                        return-object
                      />
                    </v-row>

                    <v-row>
                      <v-icon>mdi-texture-box</v-icon>
                      <p style="margin-top: 15px; margin-left: 5px">
                        Ermittlung der  Gebäudegrundfläche
                      </p>
                    </v-row>

                    <AreaItem
                      v-for="(areaUi, index) in areaUis"
                      v-bind:key="index"
                      class="area-item"
                      @area-change="areaUi.area = $event"
                      @delete-item="areaUis.length > 1 ? areaUis.pop() : null"
                      @add-item="areaUis.push({area: 0})"
                      :defaultLength="defaultLength"
                      :defaultWidth="defaultWidth"
                      :showAddButton="(index + 1) === areaUis.length"
                      :disableDeleteButton="(areaUis.length === 1) && (index === 0)"
                    />

                    <v-row style="margin-bottom: 30px;">
                      <v-divider/>
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model.number="numFloors"
                        label="Anzahl Geschosse"
                        name="bldg-floors"
                        prepend-icon="mdi-layers-triple"
                        type="number"
                        min="0"
                        :disabled="gewerblich"
                        inputmode="numeric"
                      />
                    </v-row>

                    <v-row>
                      <v-select
                        v-model="roofSelect"
                        :items="roofItems"
                        label="Dachgeschoss"
                        prepend-icon="mdi-home-roof"
                        :disabled="gewerblich"
                        return-object
                      />
                    </v-row>

                    <v-row>
                      <v-select
                        v-model="cellarSelect"
                        :items="cellarItems"
                        label="Keller"
                        prepend-icon="mdi-dock-bottom"
                        :disabled="gewerblich"
                        return-object
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        name="correction-factor"
                        label="Korrekturfaktor"
                        prepend-icon="mdi-arrow-up-down-bold"
                        v-model.number="correctionFactor"
                        inputmode="decimal"
                        type="number"
                        min="0"
                        step="0.1"
                        dense
                      />
                    </v-row>

                    <!-- RESULTS -->
                    <v-row >
                      <v-col
                        v-if="!$vuetify.breakpoint.mobile"
                      />
                      <v-col >
                        <ResultView
                          class="result-list"
                          :gewerblich="gewerblich"
                          :totalArea="totalArea"
                          :volumeRoof="volumeRoof"
                          :volumeBuilding="volumeBuilding"
                          :volumeBasement="volumeBasement"
                          :totalVolume="totalVolume"
                          :herstellungswert="herstellungswert"
                          :correctionFactor="correctionFactor"
                          :finalResult="finalResult"
                        />
                        <!-- RESET -->
                        <v-row
                          justify="end"
                        >
                          <v-btn
                            @click="onReset"
                            color="primary"
                            class="reset-button"
                          >
                            Reset
                            <v-icon>mdi-restart</v-icon>
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- DISCLAIMER -->
                    <v-row>
                      <p class="disclaimer caption">
                        * Überschlägige Ermittlung der Herstellungskosten (durchschnittlichen Normalherstellungskosten)
                        für Rheinland-Pfalz nach GebVermGAVO von 2016.
                      </p>
                    </v-row>
                    <v-row>
                      <p class="disclaimer caption">
                        Alle Angaben ohne Gewähr. Es wird keine Garantie für die Richtigkeit der Berechnung gegeben. Haftung ausgeschlossen.
                      </p>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
</template>

<script>
import AreaItem from './components/AreaItem.vue';
import ResultView from './components/ResultView.vue';
import InfoWindow from './components/InfoWindow.vue';

export default {
  name: 'app',
  components: {
    AreaItem,
    ResultView,
    InfoWindow
  },
  props: {
    toolbarTitle: {default: 'Ermittlung Herstellungswert* Gebäude RLP'},
    websiteTitle: {default: 'Ermittlung Herstellungswert* Gebäude RLP'}
  },
  data () {
    return {
      defaultLength: 7,
      defaultWidth: 10,
      correctionFactor: 1.0,
      areaUis: [{area: 0}],
      numFloors: 2,
      buildingTypeSelect: null,
      buildingTypeItems: [
        {
          text: 'Ein-/Zweifamilienhäuser',
          factor: 2.7,
          herstellungswert: 290
        },
        {
          text: 'Mietwohnhäuser',
          factor: 2.7,
          herstellungswert: 290
        },
        {
          text: 'Gemischtgenutzte Gebäude',
          factor: 2.7,
          herstellungswert: 290
        },
        {
          text: 'Büro- und Verwaltungsgebäude',
          factor: 2.7,
          herstellungswert: 375
        },
        {
          text: 'Garagen',
          factor: 2.5,
          herstellungswert: 135
        },
        {
          text: 'Stall',
          factor: 2.7,
          herstellungswert: 100
        },
        {
          text: 'Hofscheune',
          factor: 2.7,
          herstellungswert: 65
        },
        {
          text: 'Feldscheune',
          factor: 2.7,
          herstellungswert: 45
        },
        {
          text: 'Stall / Scheune',
          factor: 2.7,
          herstellungswert: 90
        },
        {
          text: 'unterkellerte Betriebsgebäude',
          factor: 2.7,
          herstellungswert: 135
        },
        {
          text: 'Geräteschuppen, Lagerhallen Leichtbauweise',
          factor: 2.7,
          herstellungswert: 220,
          gewerblich: true
        },
        {
          text: 'Eingeschossige Hallen mit normaler Ausstattung an Büro- und Sozialräumen, Großgaragen, Werkstätten',
          factor: 2.7,
          herstellungswert: 340,
          gewerblich: true
        },
        {
          text: 'Eingeschossige Hallen mit hohem Anteil an Büro-, Sozial- oder Ausstellungsräumen',
          factor: 2.7,
          herstellungswert: 520,
          gewerblich: true
        },
        {
          text: 'Eingeschossige Hallen wie vorstehend, jedoch voll unterkellert',
          factor: 2.7,
          herstellungswert: 810,
          gewerblich: true
        }
      ],
      roofSelect: null,
      roofItems: [
        {
          text: 'voll ausgebaut',
          factor: 1.75
        },
        {
          text: 'halb ausgebaut',
          factor: 1.75 / 2
        },
        {
          text: 'nicht ausgebaut',
          factor: 1.75 / 3
        },
        {
          text: 'Flachdach',
          factor: 0
        }
      ],
      cellarSelect: null,
      cellarItems: [{
        text: 'ganz unterkellert',
        factor: 2.7
      }, {
        text: 'halb unterkellert',
        factor: 1.35
      }, {
        text: 'nicht unterkellert',
        factor: 0
      }],
    }
  },
  created () {
    // select default items
    this.roofSelect = this.roofItems[0];
    this.cellarSelect = this.cellarItems[0];
    document.title = this.websiteTitle;
  },
  methods: {
    onReset () {
      this.buildingTypeSelect = null;
      this.areaUis = [];
      // This is somehow necessary that Vue actually registers the change
      this.$nextTick(()=>{
        this.areaUis = [{area: 0}];
      })
      this.numFloors = 2;
      this.roofSelect = this.roofItems[0];
      this.cellarSelect = this.cellarItems[0];
      this.correctionFactor = 1.0;
    }
  },
  computed: {
    gewerblich: function () {
      if (this.buildingTypeSelect) {
        return this.buildingTypeSelect.gewerblich;
      } else {
        return true;
      }
    },
    totalArea: function () {
      let sum = 0;
      this.areaUis.forEach((item) => {
        sum += parseFloat(item.area, 10);
      });

      return sum;
    },
    volumeRoof: function () {
      if (this.totalArea && this.roofSelect) {
        return this.totalArea * this.roofSelect.factor;
      }
      return undefined;
    },
    volumeBuilding: function () {
      if (this.buildingTypeSelect) {
        return this.totalArea * this.numFloors * this.buildingTypeSelect.factor;
      }
      return undefined;
    },
    volumeBasement: function () {
      if (this.cellarSelect) {
        return this.totalArea * this.cellarSelect.factor;
      }
      return undefined;
    },
    totalVolume: function () {
      return this.volumeRoof + this.volumeBasement + this.volumeBuilding;
    },
    finalResult () {
      if (this.buildingTypeSelect) {
        let multiplier;
        if (this.buildingTypeSelect.gewerblich) {
          multiplier = this.totalArea;
        } else {
          multiplier = this.totalVolume;
        }
        return multiplier * this.buildingTypeSelect.herstellungswert * this.correctionFactor;
      }
      return undefined;
    },
    herstellungswert: function () {
      if (this.buildingTypeSelect) {
        return this.buildingTypeSelect.herstellungswert
      }
      return undefined;
    }
  },
}

</script>

<style>

.disclaimer {
  margin: 0px 30px;
  color: darkgray;
}

.appTitle {
  font-size: small;
  font-weight: bold;
  word-wrap: normal;
  white-space: unset;
  text-align: center;
}

.reset-button {
  margin: 0 20px 20px 0;
}

/* TODO check if media query would be better here */
.v-badge.betaBadge {
  margin-top: -15px;
  margin-left: 8px;
}
.v-badge.betaBadgeMobile {
  margin-top: -24px;
  margin-left: -12px;
}

</style>
